import { render, staticRenderFns } from "./b-popup-account.vue?vue&type=template&id=a45ef64a&scoped=true"
import script from "./b-popup-account.vue?vue&type=script&lang=js"
export * from "./b-popup-account.vue?vue&type=script&lang=js"
import style0 from "./b-popup-account.vue?vue&type=style&index=0&id=a45ef64a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45ef64a",
  null
  
)

export default component.exports